import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-grid -y-0" }
const _hoisted_3 = {
  key: 0,
  class: "-mobile-steps__counter"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "o-form-response -error"
}
const _hoisted_7 = { class: "o-form-response__inner" }
const _hoisted_8 = { class: "o-text" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "o-form-response__inner" }
const _hoisted_11 = { class: "o-text" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "o-form-response__text"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "o-form__sections__wrapper" }
const _hoisted_19 = { class: "form-id" }
const _hoisted_20 = { class: "o-form__item o-flex -flex-gap-xs -flex-end -flex-w-100p" }
const _hoisted_21 = { class: "-mobile-steps" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico icon-arrow-right-full",
    "aria-hidden": "true",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=eb7dc8822a82d06af9916882#arrow-left" })
  ])
], -1 /* HOISTED */)
const _hoisted_24 = { class: "o-button__text" }
const _hoisted_25 = { class: "o-button__text__elm" }
const _hoisted_26 = {
  key: 1,
  class: "o-form__tools"
}
const _hoisted_27 = { class: "o-button__text" }
const _hoisted_28 = { class: "o-button__text__elm" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "o-button__text" }
const _hoisted_31 = { class: "o-button__text__elm" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico icon-arrow-right-full",
    "aria-hidden": "true",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=eb7dc8822a82d06af9634180#arrow-right" })
  ])
], -1 /* HOISTED */)
const _hoisted_33 = { class: "o-button__text" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "o-button__icos" }
const _hoisted_36 = { class: "o-button__ico" }
const _hoisted_37 = { class: "o-button__ico" }
const _hoisted_38 = {
  key: 1,
  style: {"margin-top":"16px"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_40 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_svgIco = _resolveComponent("svgIco")
  const _component_FormStepper = _resolveComponent("FormStepper")
  const _component_FormRecoverModal = _resolveComponent("FormRecoverModal")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-flexible-forms-v2 -theme-color-white", { '-with-stepper': $options.useStepper }]),
    "data-component-name": _ctx.$options.name
  }, [
    _createElementVNode("div", _hoisted_2, [
      ($options.useStepper)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ($options.useStepper && $data.form.currentStep + 1 < $data.stepperSections.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($data.form.currentStep + 1) + " / " + _toDisplayString($data.stepperSections.length), 1 /* TEXT */))
              : ($options.useStepper && $data.form.currentStep + 1 == $data.stepperSections.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($data.form.currentStep + 1) + " / " + _toDisplayString($data.stepperSections.length), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass({
                'o-grid-8 o-form-left': $options.useStepper,
                'o-grid-12': !$options.useStepper,
            })
      }, [
        ($props.limitReached)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createCommentVNode(" <div class=\"o-form-response__icon\">\n                            <svgIco icon=\"active\" v-if=\"result.status === 'success'\"></svgIco>\n                        </div> "),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "o-form-response__text",
                    innerHTML: $props.settings.formLimitResultsMessage.value
                  }, null, 8 /* PROPS */, _hoisted_9)
                ])
              ])
            ]))
          : ($data.result.status !== null || $data.result.loading === true)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass({
                        'o-form-response -error': $data.result.status === 'error',
                        'o-form-response -success': $data.result.status === 'success',
                        'o-form-response -loading': $data.result.loading === true,
                    })
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createCommentVNode(" <div class=\"o-form-response__icon\">\n                            <svgIco icon=\"active\" v-if=\"result.status === 'success'\"></svgIco>\n                        </div> "),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", {
                      class: "o-form-response__text",
                      innerHTML: ($data.result.loading == true) ? _ctx.$root.nl2br($data.loadingMessage) : _ctx.$root.nl2br($data.result.message)
                    }, null, 8 /* PROPS */, _hoisted_12),
                    ($data.result.hashedURL)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("p", null, _toDisplayString(_ctx._t('L\'URL de récupération vous a été envoyée par courriel. Vous pouvez reprendre le formulaire à tout moment.')), 1 /* TEXT */),
                          _createElementVNode("a", {
                            href: $data.result.hashedURL,
                            class: "o-button -link"
                          }, _toDisplayString(_ctx._t('Reprendre le formulaire dès maintenant')), 9 /* TEXT, PROPS */, _hoisted_14)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
        _createElementVNode("form", {
          action: "",
          class: _normalizeClass(["o-form o-flexible-form o-form-styled", {
                        'is-form-success-ready': $data.result.status === 'success',
                        'is-form-error-ready': $data.result.status === 'error',
                        'is-form-hidden': $data.formHideOnSuccess && $data.result.status === 'success',
                        'is-form-disabled': ($data.isFormDisabled || $props.limitReached),
                    }]),
          ref: 'form-'+$data.form.id,
          onChange: _cache[4] || (_cache[4] = $event => ($data.formChanged=true)),
          onInput: _cache[5] || (_cache[5] = $event => ($data.formChanged=true))
        }, [
          _createElementVNode("input", {
            type: "hidden",
            name: "formShortUUID",
            value: $options.formShortID
          }, null, 8 /* PROPS */, _hoisted_15),
          _createElementVNode("input", {
            type: "hidden",
            name: "formUUID",
            value: $data.form.id
          }, null, 8 /* PROPS */, _hoisted_16),
          _createElementVNode("input", {
            type: "hidden",
            name: "Langue",
            value: $props.currentlanguage
          }, null, 8 /* PROPS */, _hoisted_17),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.activeSections, (section, si) => {
              return (_openBlock(), _createBlock(_component_FormSection, {
                key: section.id,
                ref_for: true,
                ref: section.id,
                id: section.id,
                section: section,
                currentStep: $data.form.currentStep,
                totalSteps: $options.activeSections.length,
                disabledIDs: $options.disabledIDs
              }, null, 8 /* PROPS */, ["id", "section", "currentStep", "totalSteps", "disabledIDs"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("small", _hoisted_19, _toDisplayString('#' + $options.formShortID), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                ($data.stepperSections.length>1)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      ref: "prevButton",
                      type: "button",
                      class: "o-button -icon-reverse",
                      onClick: _cache[0] || (_cache[0] = $event => {$data.form.currentStep--;$options.saveForm({ userEmail: null, userPhone: null, autoSave: true })}),
                      disabled: $options.useStepper && $data.form.currentStep <= 0
                    }, [
                      _hoisted_23,
                      _createElementVNode("span", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx._t('Précédent')), 1 /* TEXT */)
                      ])
                    ], 8 /* PROPS */, _hoisted_22))
                  : _createCommentVNode("v-if", true),
                ($options.useStepper)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createCommentVNode(" <a \n                                    class=\"o-button -no-border\" \n                                    href=\"tel:+18006623313\" \n                                    target=\"_blank\" \n                                    rel=\"noopener noreferrer\" \n                                    aria-label=\"Ouvre dans une nouvelle fenêtre\"\n                                    :class=\"{'disabled' : showSaveModal == true}\"\n                                    >\n                                        <span class=\"o-button__text\">\n                                            <span class=\"o-button__text__elm\">\n                                                {{ _t('Aide ?') }}\n                                            </span>\n                                        </span>\n                                        <span class=\"o-button__ico\">\n                                            <svg class=\"o-ico\" aria-hidden=\"true\" role=\"img\">\n                                                <use xlink:href=\"/assets/img/sprite.svg?v=eb7dc8822a82d06af9916882#phone\"></use>\n                                            </svg>\n                                        </span>\n                                    </a> "),
                      ($data.allowRecovery === true && $data.result.status !== 'success')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "o-button -no-border",
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = $event => ($data.showSaveModal=true))
                          }, [
                            _createElementVNode("span", _hoisted_27, [
                              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx._t('Sauvegarder')), 1 /* TEXT */)
                            ]),
                            _createCommentVNode(" <span class=\"o-button__ico\">\n                                            <svg class=\"o-ico\" aria-hidden=\"true\" role=\"img\">\n                                                <use xlink:href=\"/assets/img/sprite.svg?v=eb7dc8822a82d06af9916882#save\"></use>\n                                            </svg>\n                                        </span> ")
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                ($options.activeSections.length > 1 && $data.form.currentStep + 1 < $data.stepperSections.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      ref: "nextButton",
                      type: "button",
                      class: "o-button",
                      onClick: _cache[2] || (_cache[2] = $event => {$options.validateForm($data.form.currentStep);$options.saveForm({ userEmail: null, userPhone: null, autoSave: true })}),
                      disabled: $options.useStepper && $data.form.currentStep + 1 >= $data.stepperSections.length
                    }, [
                      _createElementVNode("span", _hoisted_30, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx._t('Suivant')), 1 /* TEXT */)
                      ]),
                      _hoisted_32
                    ], 8 /* PROPS */, _hoisted_29))
                  : _createCommentVNode("v-if", true)
              ]),
              (!$options.useStepper || $data.form.currentStep + 1 == $data.stepperSections.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    ref: "submitButton",
                    type: "button",
                    class: "o-button -button-text -submit-form",
                    onClick: _cache[3] || (_cache[3] = $event => ($options.submitForm()))
                  }, [
                    _createElementVNode("span", _hoisted_33, [
                      _createElementVNode("span", {
                        class: "o-button__text__elm",
                        innerHTML: $data.submitLabel
                      }, null, 8 /* PROPS */, _hoisted_34)
                    ]),
                    _createElementVNode("span", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_svgIco, {
                          icon: "arrow-full-right",
                          class: "o-ico -ico-arrow-full-right"
                        })
                      ]),
                      _createElementVNode("span", _hoisted_37, [
                        _createVNode(_component_svgIco, {
                          icon: "arrow-full-right",
                          class: "o-ico -ico-arrow-full-right"
                        })
                      ])
                    ])
                  ], 512 /* NEED_PATCH */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ], 34 /* CLASS, NEED_HYDRATION */)
      ], 2 /* CLASS */),
      ($options.useStepper)
        ? (_openBlock(), _createBlock(_component_FormStepper, {
            key: 1,
            class: "o-grid-4 sm:4 o-form-right",
            sections: $data.stepperSections,
            currentStep: $data.form.currentStep,
            result: $data.result,
            allowRecovery: $data.allowRecovery,
            showSaveModal: $data.showSaveModal,
            onShowSaveModal: _cache[6] || (_cache[6] = $event => ($data.showSaveModal=$event)),
            onSaveForLater: _cache[7] || (_cache[7] = $event => ($options.saveForm($event))),
            onGoToStep: _cache[8] || (_cache[8] = $event => ($data.form.currentStep=$event)),
            formIsCompleted: $data.formIsCompleted
          }, null, 8 /* PROPS */, ["sections", "currentStep", "result", "allowRecovery", "showSaveModal", "formIsCompleted"]))
        : _createCommentVNode("v-if", true)
    ]),
    ($data.showRecoverModal)
      ? (_openBlock(), _createBlock(_component_FormRecoverModal, {
          key: 0,
          onCloseModal: _cache[9] || (_cache[9] = $event => ($data.showRecoverModal=false)),
          entryID: $props.entry.id,
          siteID: $props.entry.siteId,
          form: $data.form
        }, null, 8 /* PROPS */, ["entryID", "siteID", "form"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Assistant de traduction - décommenté au besoin en dev "),
    ($props.enabletranslationsassistant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("small", {
            style: {"color":"var(--color-gray)","cursor":"pointer"},
            onClick: _cache[10] || (_cache[10] = $event => ($data.translationsAssistantActive = !$data.translationsAssistantActive))
          }, [
            _createTextVNode("Afficher l'assistant de traduction"),
            _hoisted_39,
            _createTextVNode("(administrateur seulement)")
          ]),
          ($data.translationsAssistantActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createTextVNode(_toDisplayString(_ctx.$root.currentlanguage) + " ", 1 /* TEXT */),
                ($data.translationsAssistantActive)
                  ? (_openBlock(), _createElementBlock("textarea", {
                      key: 0,
                      rows: "60",
                      class: "o-input",
                      style: {"display":"none11"},
                      ref: "stringTranslations"
                    }, _toDisplayString(JSON.stringify(_ctx.$root.translationsString, null, 4)), 513 /* TEXT, NEED_PATCH */))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" <pre>{{ settings.formConsentMessageReason }}</pre>\n        <pre>{{ activeSections }}</pre> ")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}